import {Col, Container, Row} from 'react-bootstrap';
import css from '../../css/MenuItem.module.css';

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useHover} from "../../../../Hooks/visual/useHover";

const MenuItem = ({icon, text, textColor, iconColor, cursor, style, classNameContainer, iconStyle, textStyle, hoverColor, variant, onClick, enabled = true, children}) => {

    if(variant)
    {
        switch (variant) {
            case 'danger':
                textColor = textColor ?? 'red';
                iconColor = iconColor ?? 'red';
                hoverColor = hoverColor ?? '#ff00002b';
                break;
        }
    }

    if (!iconColor)
        iconColor = 'rgb(80, 80, 80)';

    if(textColor)
        textStyle = {...textStyle, color: textColor}
    if(iconColor)
        iconStyle = {...iconStyle, color: iconColor}

    style = {
            ...style,
            cursor: cursor ? cursor : ( onClick ? "pointer" : 'default'),  //If cursor is specified, it will be used. Otherwise pointer if onClick is specified, default otherwise
    }

    const disabledStyle = {
        opacity: 0.5,
        backgroundColor: '#80808069',
        borderRadius: '5px',
        cursor: 'not-allowed'
    }

    const hoverStyle = {
        backgroundColor: hoverColor || 'rgb(240, 240, 240)',
        borderRadius: '5px'
    }

    const hover = useHover(hoverStyle, enabled, enabled ? style : disabledStyle);

    return (
        <Container className={`${css.wrapper}${classNameContainer ? " " + classNameContainer : ''}`} style={enabled ? style : disabledStyle} onClick={enabled ? onClick : null} {...hover}>
            <Row>
                {
                    icon &&
                    <Col sm={1}>
                        <FontAwesomeIcon style={iconStyle} icon={icon}/>
                    </Col>
                }
                <Col>
                    <span style={textStyle}>{text ?? children}</span>
                </Col>
            </Row>
        </Container>
    );
};

export default MenuItem;